import {observer} from "mobx-react";
import {Component} from "preact";
import {PropsWithChildren} from "preact/compat";
import {Spinner} from "./controls/Spinner";
import style from "./PendingMessage.module.css";

export const PendingMessage = observer(
	class PendingMessage extends Component<PropsWithChildren<{}>> {
		render() {
			const {children} = this.props;
			return (
				<div class={style.pendingMessage}>
					<div class={style.spinner}>
						<Spinner />
					</div>
					<div class={style.message}>
						{children}
					</div>
				</div>
			);
		}
	},
);
